import { AppstoreOutlined, SettingOutlined } from '@ant-design/icons';
import {Link, useLocation} from "react-router-dom";
import {Menu, Select} from "antd";

import React, {useEffect, useState} from 'react';
import api from "../../services/api";

const Header = () => {
    const [groups, setGroups] = useState([]);

    const location = useLocation();

    useEffect(() => {
        (async () => {
            const response = await api.groups();

            setGroups(response.data);
        })()
    }, [])

    const onChange = (value: any) => {
        if(value === "all") localStorage.removeItem('group');
        else localStorage.setItem('group', value);

        window.location.reload()
    }

    return (
            <Menu mode="horizontal" style={{ width: '100%', display: 'flex', alignItems: 'center', height: '60px' }}>
                <div style={{ display: 'flex' }}>
                    <Link to={'/'}>
                        <Menu.Item key="mail" icon={<AppstoreOutlined />}>
                            Map
                        </Menu.Item>
                    </Link>
                    <Link to={'/options'}>
                        <Menu.Item key="SubMenu" title="Navigation Two - Submenu" icon={<SettingOutlined />}>
                            Options
                        </Menu.Item>
                    </Link>

                    {
                        location.pathname === '/' && (
                            <Menu.Item>
                                <Select placeholder={"Group:"} defaultValue={localStorage.getItem('group') || null} style={{ width: 120 }} onChange={onChange}>
                                    <Select.Option value={"all"}>ALL</Select.Option>
                                    {
                                        groups.map((row: any, id) => <Select.Option key={id} value={row._id}>{row.name}</Select.Option>)
                                    }
                                </Select>
                            </Menu.Item>
                        )
                    }

                </div>

                <div style={{ position: 'absolute', right: 0 }}>
                    <Menu.Item key="SubMenu" title="Navigation Two - Submenu" icon={<SettingOutlined />} onClick={() => {
                        localStorage.removeItem('token')

                        window.dispatchEvent(new Event("storage"));
                    }}>
                        Logout
                    </Menu.Item>
                </div>
            </Menu>
    );
};

export default Header;